export default "__VITE_ASSET__BUbLp64x__"